import React from "react";
import { Link } from "react-router-dom";
import TRNDLogo from "../Assets/Images/TRND_logo.png";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLinkedin, faTwitter, faFacebook, faInstagram, faYoutube } from '@fortawesome/free-brands-svg-icons';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer id="footer">
      <div className="footer-container">
        {/* Main Footer Content */}
        <div className="footer-main">
          <div className="footer-columns">
            {/* Column 1 - Brand Identity */}
            <div className="footer-column brand-column">
              <Link to="/" className="footer-logo">
                <img src={TRNDLogo} alt="TRND" />
              </Link>
              <p className="footer-tagline">
                Empowering businesses with data-driven marketing solutions that combine science with creativity.
              </p>
            </div>

            {/* Column 2 - Company */}
            <div className="footer-column">
              <h3 className="footer-heading">Company</h3>
              <ul className="footer-links">
                <li><Link to="/about-us">About Us</Link></li>
                <li><Link to="/contact">Contact</Link></li>
                <li><Link to="/affiliate">Affiliate Program</Link></li>
                <li><Link to="/agencies">Agencies</Link></li>
              </ul>
            </div>

            {/* Column 3 - Services */}
            <div className="footer-column">
              <h3 className="footer-heading">Services</h3>
              <ul className="footer-links">
                <li><Link to="/discover">Discover</Link></li>
                <li><Link to="/marketing-services">Marketplace</Link></li>
                <li><Link to="/marketing-genius">Marketing Genius</Link></li>
                <li><Link to="/ai-marketing-tools">AI Marketing Tools</Link></li>
                <li><Link to="/subscriptions-plans">Plans & Pricing</Link></li>
              </ul>
            </div>

            {/* Column 4 - Support */}
            <div className="footer-column">
              <h3 className="footer-heading">Support</h3>
              <ul className="footer-links">
                <li><Link to="/help-center">Help Center</Link></li>
                <li><Link to="/resources">Resources</Link></li>
                <li><Link to="/terms-and-conditions">Terms & Conditions</Link></li>
                <li><Link to="/privacy-policy">Privacy Policy</Link></li>
                <li><Link to="/refund-policy">Refund Policy</Link></li>
              </ul>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            {/* Social Media Icons */}
            <div className="footer-social">
              <a href="https://linkedin.com/company/trnd" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                <FontAwesomeIcon icon={faLinkedin} />
              </a>
              <a href="https://twitter.com/trnd" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
                <FontAwesomeIcon icon={faTwitter} />
              </a>
              <a href="https://facebook.com/trnd" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                <FontAwesomeIcon icon={faFacebook} />
              </a>
              <a href="https://instagram.com/trnd" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                <FontAwesomeIcon icon={faInstagram} />
              </a>
              <a href="https://youtube.com/trnd" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
                <FontAwesomeIcon icon={faYoutube} />
              </a>
            </div>

            {/* Legal Links */}
            <div className="footer-legal">
              <Link to="/privacy-policy">Privacy Policy</Link>
              <span className="separator">|</span>
              <Link to="/terms-and-conditions">Terms & Conditions</Link>
              <span className="separator">|</span>
              <Link to="/cookie-policy">Cookie Policy</Link>
              <span className="separator">|</span>
              <Link to="/refund-policy">Refund Policy</Link>
            </div>

            {/* Copyright */}
            <div className="footer-copyright">
              © Copyright {currentYear}, TRND. All Rights Reserved
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
